import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import NumericPicker from '../Numeric/Picker';
var VALUE_UNSPECIFIED = 'Inherit';
/**
 * @extends {React.PureComponent<import('../types').FormInputLengthProps> }
 */

/** Length picker. Supports px, pt, em, %.
 * Unknown input is treated as null. */

var LengthPicker =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(LengthPicker, _React$PureComponent);

  function LengthPicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LengthPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LengthPicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      measurementUnit: getMeasurementUnit(_this.props.value, _this.props.defaultMeasurementUnit),
      numericValue: parseFn(_this.props.value),
      options: (_this.props.options ? _this.props.options[getMeasurementUnit(_this.props.value, _this.props.defaultMeasurementUnit)] : []) || []
    };

    _this.format = function (val) {
      return formatFn(_this.state.measurementUnit, _this.props.unspecifiedValue, val);
    };

    _this.parse = function (val) {
      var mu = getMeasurementUnit(val, _this.props.defaultMeasurementUnit); //entered manually

      return parseFn(val) + mu;
    };

    _this.onChange = function (val) {
      var mu = null;
      var numericVal = null;

      if (typeof val === 'string') {
        //entered manually
        mu = getMeasurementUnit(val, _this.props.defaultMeasurementUnit);
        numericVal = parseFn(val);

        if (_this.state.measurementUnit !== mu) {
          _this.setState({
            measurementUnit: mu
          });
        }
      } else if (typeof val === 'number') {
        mu = _this.state.measurementUnit;
        numericVal = val;
      }

      if (numericVal === null) _this.props.onChange(null);else if (mu !== _this.props.defaultMeasurementUnit) _this.props.onChange(numericVal + mu);else _this.props.onChange(numericVal);
    };

    return _this;
  }

  _createClass(LengthPicker, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          numericValue = _this$state.numericValue,
          options = _this$state.options;
      var _this$props = this.props,
          icon = _this$props.icon,
          label = _this$props.label,
          tooltip = _this$props.tooltip,
          unspecifiedValue = _this$props.unspecifiedValue,
          showCurrentValueInDropdown = _this$props.showCurrentValueInDropdown,
          width = _this$props.width;
      return React.createElement(NumericPicker, {
        value: numericValue,
        onChange: this.onChange,
        label: label,
        tooltip: tooltip,
        icon: icon,
        format: this.format,
        parse: this.parse,
        options: options,
        width: width,
        unspecifiedValue: unspecifiedValue,
        showCurrentValueInDropdown: showCurrentValueInDropdown,
        "data-testid": icon + '-picker'
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newMU = getMeasurementUnit(nextProps.value, nextProps.defaultMeasurementUnit);
      var newVal = parseFn(nextProps.value);

      if (newMU !== prevState.measurementUnit || newVal !== prevState.numericValue) {
        return {
          measurementUnit: newMU,
          numericValue: newVal,
          options: (nextProps.options ? nextProps.options[newMU] : []) || []
        };
      } else {
        return null;
      }
    }
  }]);

  return LengthPicker;
}(React.PureComponent);

function formatFn(measurementUnit, unspecifiedValue, num) {
  if (num === null) return unspecifiedValue;
  return num + ' ' + measurementUnit;
}

function parseFn(stringValue) {
  if (stringValue === null) return null;
  var number = parseFloat(stringValue);
  if (Number.isNaN(number)) return null;
  return number;
}

function getMeasurementUnit(stringValue, defaultMeasurementUnit) {
  if (!stringValue) return defaultMeasurementUnit;
  if (typeof stringValue === 'number') return defaultMeasurementUnit;

  if (typeof stringValue === 'string') {
    if (stringValue.indexOf('pt') > -1) return 'pt';
    if (stringValue.indexOf('em') > -1) return 'em';
    if (stringValue.indexOf('px') > -1) return 'px';
    if (stringValue.indexOf('%') > -1) return '%';
  }

  return defaultMeasurementUnit;
}

LengthPicker.defaultProps = {
  unspecifiedValue: VALUE_UNSPECIFIED,
  label: '',
  defaultMeasurementUnit: 'px',
  showCurrentValueInDropdown: false,
  'data-testid': 'length-picker'
};
export default LengthPicker;